import { request } from '../util/request'
import { AppCode } from '../util/auth'

/**
 * @name GetJsApiConfig
 * @desc 微信配置接口、微信分享调用
 * @param {object} data
 * @param {string} data. webUrl
 * @param {string} data.appId
 * @param {string} data.token
 *
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */

export function GetJsApiConfig (data = {
  appId: AppCode,
  webUrl: location.href.split('#')[0]
}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/getJsApiConfig`,
    method: 'POST',
    data,
    loadingConfig
  })
}